import React, { useState, useEffect } from 'react';
import { Loader } from './Loader';
import Error from '../molecules/Error';
import GridHeader from '../molecules/GridHeader';
import PlayerCard from './PlayerCard';
import { teamsData } from '../data';

import ChiefsImage from '../assets/icons/kansas-city-chiefs-logo-transparent.png';
import Eagles from '../assets/icons/philadelphia_eagles_logo_primary_19964867.png';

export default function PlayerGrid() {
    const [data, setData] = useState({});
    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedTeam, setSelectedTeam] = useState('teamA');


    const TeamLogos = {
        'teamA': ChiefsImage,
        'teamB': Eagles
    };


    useEffect(() => {
        const setVh = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };
        setVh();
        window.addEventListener('resize', setVh);
        return () => window.removeEventListener('resize', setVh);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            try {
                setData(teamsData);
                setLoading(false);
            } catch (error) {
                setError(`Failed to load data: ${error.message}`);
                setLoading(false);
            }
        }, 1000);

        return () => clearTimeout(timer);
    }, []);



    if (loading) {
        return <Loader />;
    }
    if (error) {
        return <Error errorMessage={error} />;
    }

    const currentTeam = data[selectedTeam];


    return (
        <div className="min-h-screen bg-white flex flex-col items-center p-2">
            <div className="w-full flex justify-center mb-4 pt-4 sticky top-0 z-10 bg-white">
                <button
                    className={`px-4 py-2 mr-2 rounded ${selectedTeam === 'teamA' ? 'bg-[#E31837] text-white' : 'bg-gray-200'}`}
                    onClick={() => setSelectedTeam('teamA')}
                >
                    Chiefs
                </button>

                <button
                    className={`px-4 py-2 rounded ${selectedTeam === 'teamB' ? 'bg-[#004c54] text-white' : 'bg-gray-200'}`}
                    onClick={() => setSelectedTeam('teamB')}
                >
                    Eagles
                </button>
            </div>

            <div className="w-full flex flex-col flex-1">
                <GridHeader
                    teamLogo={TeamLogos[selectedTeam]}
                    teamName={currentTeam.name}
                    sportName={currentTeam.market}
                />

                <div
                    className="flex-1 overflow-y-auto"
                    style={{ maxHeight: 'calc(var(--vh, 1vh) * 100 - 80px - 80px)' }}
                >
                    {currentTeam.players.map((player) => (
                        <div
                            key={player.name}
                            className="flex items-center p-2 border-b border-gray-200 cursor-pointer hover:bg-gray-200"
                            onClick={() => setSelectedPlayer(player)}
                        >
                            <img
                                src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                                alt={player.name}
                                className="w-6 h-6 rounded-full mr-2"
                            />
                            <div className="flex justify-between w-full">
                                <span className="text-sm flex-1">{player.name}</span>
                                <span className="text-sm flex-1 font-bold">{player.jersey}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {selectedPlayer && (
                <PlayerCard
                    player={selectedPlayer}
                    onClose={() => setSelectedPlayer(null)}
                    teamLogo={null}
                    teamName={selectedTeam}
                />
            )}
        </div>
    );
}